export default __webpack_public_path__ + "static/media/icon-scientific-research.c703e95b.svg";